<template>
    <div class="muse-audio">
        <div class="loading-tip" v-if="loading">加载中...</div>
        <div class="error-tip" v-if="error">{{error}}</div>
        <div class="controls" v-if="showControl">
            <veui-button ui="link"
                :disabled="canPlay == null"
                class="play-btn"
                @click="playOrPause">
                <veui-icon :name="iconName"/></veui-button>
            <div class="time-wrap">
                <span ref="timePlayed" class="time-played">{{ realCurrentTime | time }}</span>
                /
                <span ref="timeTotal" class="time-total">{{ totalTime | time }}</span>
            </div>
            <div class="slider-wrap">
                <veui-slider v-model="percent" :min="0" :max="totalTime || 0"/>
            </div>
        </div>
        <audio class="media-player"
            ref="media"
            :src="src"
            v-on="mediaListeners"/>
    </div>
</template>

<script>
import {Button, Slider, Icon} from 'veui';
import '@/../assets/icons/play.svg';
import '@/../assets/icons/pause.svg';
import mediaMixin from './shared';

export default {
    name: 'MuseAudio',
    components: {
        'veui-button': Button,
        'veui-slider': Slider,
        'veui-icon': Icon
    },
    mixins: [mediaMixin]
};
</script>

<style lang="less">
@import '~@/common/css/variables.less';
.muse-audio {
    position: relative;

    .play-btn {
        float: left;
    }
    .time-wrap {
        float: left;
        line-height: 36px;
        margin-left: 6px;
    }
    .slider-wrap {
        overflow: auto;
        padding: 0 10px;
    }

    .media-player {
        display: none;
    }

    .error-tip, .loading-tip {
        width: 100%;
        text-align: center;
    }
    .error-tip {
        color: @muses-red;
    }
}
</style>
